import type { CSSProperties, MouseEvent } from 'react';
import { forwardRef } from 'react';
import cx from 'clsx';

import { CloseIcon } from '~/assets/icons';

type Props = {
  onClose: () => void;
  className?: string;
  style?: CSSProperties;
};

const stopEvent = (e: MouseEvent) => {
  e.stopPropagation();
  e.preventDefault();
};

/**
 * 스탠다드 멤버십 넛지 툴팁의 view 전용 컴포넌트.
 * 카드 박스 스타일 + 내용만 담당하며, 위치/열림 로직은 감싸는 쪽에서 책임진다.
 */
export const MembershipStandardNudgeTooltipContent = forwardRef<
  HTMLDivElement,
  Props
>(function MembershipStandardNudgeTooltipContent(
  { onClose, className, style },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cx(
        'w-[calc(100vw-40px)] max-w-[calc(768px-40px)] rounded-16 border border-gray-300 bg-gray-000 px-20 py-16 shadow-[0_4px_8px_0px_rgba(0,0,0,0.1)]',
        className,
      )}
      style={style}
      role="presentation"
      onClick={stopEvent}
    >
      <div className="mb-8 flex items-start">
        <p className="flex-1 text-normal typo-paragraph100-semibold">
          스탠다드 멤버십쿠폰가
        </p>
        <CloseIcon
          className="size-20 text-icon"
          onClick={(e) => {
            stopEvent(e);
            onClose();
          }}
        />
      </div>
      <p className="mb-4 text-error typo-footnote300-semibold">
        스탠다드 멤버십 가입 시 지급되는 혜택이 적용되었어요!
      </p>
      <p className="text-description typo-footnote300-regular">
        주문 시 실제 사용되는 쿠폰에 따라 할인 금액이 변동될 수 있습니다.
      </p>
    </div>
  );
});
